import { stopAnimation } from './animationControls';
import { applyParticleRuntimeHidden } from '../ThreeJsUtils/assetVisibilityUtils';

function clearLifeTimeout(obj) {
  try {
    if (obj && obj.userData && obj.userData._lifeTimeoutId) {
      clearTimeout(obj.userData._lifeTimeoutId);
      obj.userData._lifeTimeoutId = null;
    }
  } catch (e) {
    // ignore
  }
}

function setLifeTimeout(obj, seconds) {
  clearLifeTimeout(obj);
  if (!obj) return;

  if (obj.userData) {
    obj.userData.lifeExpired = false;
  }

  if (typeof seconds !== 'number' || seconds <= 0) return;
  try {
    obj.userData._lifeTimeoutId = setTimeout(
      () => {
        try {
          stopAnimation(obj, obj.name);
        } catch (e) {}
        applyParticleRuntimeHidden(obj, true);
        if (obj.userData) {
          obj.userData.lifeExpired = true;
          obj.userData.isStopped = true;
          obj.userData.isPlaying = false;
        }
      },
      Math.max(0, seconds) * 1000
    );
  } catch (err) {
    console.warn('Failed to set life timeout for particle system', err);
  }
}

export { setLifeTimeout, clearLifeTimeout };
